import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { moneyFlowService } from '../../../services'
import { parseHttpError } from '../../utils'
import { parseBillMoney } from './utils'
import { selectors } from './selectors'
import { TBillMoneysState } from '../../types'
import { billMoneysAdapter } from './adapter'

const name = 'billMoneys'

const initialState: TBillMoneysState = {
    ...billMoneysAdapter.getInitialState(),
    isFetching: false
}

const fetch = createAsyncThunk(
    `${name}/fetch`,
    async () => {
        return parseBillMoney(await moneyFlowService.fetchBillTypes())
    },
    {
        serializeError: parseHttpError
    }
)

const slice = createSlice({
    name,
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(fetch.pending, (state) => {
                state.isFetching = true
                state.fetchError = undefined
            })
            .addCase(fetch.fulfilled, (state, action) => {
                state.isFetching = false
                billMoneysAdapter.setAll(state, action.payload)
            })
            .addCase(fetch.rejected, (state, action) => {
                state.isFetching = false
                state.fetchError = action.error
            })
})

export const billMoneys = {
    name: slice.name,
    actions: {
        fetch,
    },
    reducer: slice.reducer,
    selectors,
}